import { ziggyGetRoute as getRoute } from '@/router/ziggyGetRoute';
import { obj } from '@/util'
import { _tenant, _game } from "@/state";

export const UserNotificationsRoutes = {

	GetAllUnreadNotifications: async (args = {}) => {
		args.tenant = args.tenant || _tenant().slug
		return await api().get(getRoute('api.notifications.index', args));
	},

	MarkAllNotificationsAsRead: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().patch(getRoute('api.notifications.updateAllAsRead', { tenant }));
	},

	MarkNotificationAsRead: async ({ tenant, notification } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().patch(getRoute('api.notifications.updateAsRead', { tenant, notification }));
	}

}

const indexCallAdaptFormGame = async (resource, args) => {
	if (!resource) { return; }

	args.tenant = args.tenant || _tenant().slug
	args.game = args.game || _game().id
	args.sprint = args.sprint ?? _game().sprint ? _game().sprint.id : null;
	if (!args.game) { delete args.game }

	let route = (!!args.game ? 'api.games.' + resource + '.index' : 'api.' + resource + '.index')
	return await api().get(getRoute(route, args));
}

export const GamesRoutes = {

	GetAllGames: async (args) => {
		args.tenant = args.tenant || _tenant().slug
		args.sprint = args.sprint ?? _game().sprint ? _game().sprint.id : null;
		return await api().get(getRoute('api.games.index', args));
	},

	GetGame: async ({ tenant, game, sprint }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.games.show', { tenant, game: game, sprint: sprint }));
	},

	CreateGame: async ({ tenant, game }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.games.store', { tenant }), obj.objToFormData(game));
	},

	UpdateGame: async ({ tenant, game }) => {
		tenant = tenant || _tenant().slug
		game._method = 'PATCH'
		let sprint = _game().sprint ? _game().sprint.id : null;
		return await api().post(getRoute('api.games.update', { tenant, game, sprint: sprint }), obj.objToFormData(game));
	},

	DeleteGame: async ({ tenant, game }) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.games.destroy', { tenant, game }));
	},

	RestoreGame: async ({ tenant, game }) => {
		tenant = tenant || _tenant().slug
		let game_id = game.id;
		return await api().post(getRoute('api.games.restore', { tenant, game_id }));
	},

	ForceDeleteGame: async ({ tenant, game }) => {
		tenant = tenant || _tenant().slug
		let game_id = game.id;
		return await api().post(getRoute('api.games.force_delete', { tenant, game_id }));
	},

	GetGameLeaderboard: async ({ tenant, game, sprint }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.games.leaderboard', { tenant, game, sprint }));
	},

	GetGameMomentum: async ({ tenant, game, sprint }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.games.momentum', { tenant, game, sprint }));
	},
}

export const SprintRoutes = {

	GetAllSprints: async ({ tenant, game, sprint } = {}) => {
		tenant = tenant || _tenant().slug
		game = game || _game().id
		sprint = sprint ?? _game().sprint ? _game().sprint.id : null;
		return await api().get(getRoute('api.games.sprints.index', { tenant, game, sprint }));
	},

	GetSprint: async ({ tenant, sprint } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.games.sprints.show', { tenant, sprint }));
	},

	CreateSprint: async ({ tenant, game, sprint } = {}) => {
		tenant = tenant || _tenant().slug
		game = game || _game().id
		return await api().post(getRoute('api.games.sprints.store', { tenant, game }), obj.objToFormData(sprint));
	},

	UpdateSprint: async ({ tenant, sprint } = {}) => {
		tenant = tenant || _tenant().slug
		sprint._method = 'PATCH'
		return await api().post(getRoute('api.games.sprints.update', { tenant, sprint }), obj.objToFormData(sprint));
	},

	ReplicateSprint: async ({ tenant, sprint }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.games.sprints.replicate', { tenant, sprint }), obj.objToFormData(sprint));
	},

	DeleteSprint: async ({ tenant, sprint } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.games.sprints.destroy', { tenant, sprint }));
	},

	ShowReport: async ({ tenant, data } = {}) => {
		tenant = tenant || _tenant().slug
		let sprint = _game().sprint ? _game().sprint.id : null;
		return await api().post(getRoute('api.reports.index', { tenant, sprint }), obj.objToFormData(data));
	},

	ShowUserReport: async ({ tenant, data } = {}) => {
		tenant = tenant || _tenant().slug
		let user = data.user;
		let sprint = _game().sprint ? _game().sprint.id : null;
		return await api().post(getRoute('api.reports.show', { tenant, sprint, user }), obj.objToFormData(data));
	},

	DownloadReport: async ({ tenant, data } = {}) => {
		tenant = tenant || _tenant().slug
		data.sprint = _game().sprint ? _game().sprint.id : null;
		return await api().post(getRoute('api.reports.download', { tenant }), obj.objToFormData(data));
	}
}


export const ActionsRoutes = {

	GetAllActions: async (args) => {
		let tenant = args.tenant || _tenant().slug
		return await api().get(getRoute('api.actions.index', { tenant }));
	},

	GetAllGameActions: async (args) => {
		return await indexCallAdaptFormGame('actions', args);
	},

	GetAction: async ({ tenant, action }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.actions.show', { tenant, action }));
	}
}

export const TotalActionsRoutes = {

	CreateTotalAction: async ({ tenant, action }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.totalactions.store', { tenant }), obj.objToFormData(action));
	},

	UpdateTotalAction: async ({ tenant, action }) => {
		tenant = tenant || _tenant().slug
		action._method = 'PATCH'
		let action_id = action.id;
		return await api().post(getRoute('api.totalactions.update', { tenant, action: action_id }), obj.objToFormData(action));
	},

	// NOTE: Using *post* request here to send a request body in order to delete multiple actions if necessary
	DeleteTotalAction: async ({ tenant, action }) => {
		tenant = tenant || _tenant().slug
		// action._method = 'PATCH'
		let action_id = action.id;
		return await api().post(getRoute('api.totalactions.destroy', { tenant, action: action_id }), obj.objToFormData(action));
	},
}

export const SprintPlannerRoutes = {

	UpdateSprintPlanner: async ({ tenant, data }) => {
		tenant = tenant || _tenant().slug
		data._method = 'PATCH'
		return await api().post(getRoute('api.sprintplanner.update', { tenant }), obj.objToFormData(data));
	},
}

export const ActivitiesRoutes = {

	GetAllActivities: async (args) => {
		return await indexCallAdaptFormGame('activities', args)
	},

	SearchAllActivities: async ({ tenant, page, per_page, searchTerm }) => {
		tenant = tenant || _tenant().slug
		let game = _game().id;
		let sprint = _game().sprint ? _game().sprint.id : null;
		return await api().get(getRoute('api.activities.find', { tenant, searchTerm, game, sprint, page, per_page }));
	},

	CreateActivity: async ({ tenant, activity }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.activities.store', { tenant }), activity);
	},

	DeleteActivity: async ({ tenant, activity }) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.activities.destroy', { tenant, activity }));
	},

	GetActivityHubspotLink: async ({ tenant, activity }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.activities.hubspot.link', { tenant, activity }));
	},

	GetActivityHubspotLinkWithEngagement: async ({ tenant, engagement_id, type }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.activities.hubspot.link.engagement', { tenant, engagement_id, type }));
	},

	GetAllHubspotActivities: async ({ tenant, sprint, type, page, filteredUserIds, filteredActionIds, filteredTypes, start, end }) => {
		tenant = tenant || _tenant().slug
		return await api().post(
			getRoute('api.activities.hubspot', { tenant }),
			obj.objToFormData({ sprint, type, page, filteredUserIds, filteredActionIds, filteredTypes, start, end })
		);
	}
}

export const MissionsRoutes = {

	GetAllMissions: async (args) => {
		args.sprint = args.sprint ?? _game().sprint ? _game().sprint.id : null;
		return await indexCallAdaptFormGame('missions', args);
	},

	GetMission: async ({ tenant, mission }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.missions.show', { tenant, mission }));
	},

	GetMissionMomentum: async ({ tenant, mission }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.missions.momentum', { tenant, mission }));
	}

}

export const GoalsRoutes = {

	GetAllGoals: async (args) => {
		args.sprint = args.sprint ?? _game().sprint ? _game().sprint.id : null;
		return await indexCallAdaptFormGame('goals', args)
	},

	GetGoal: async ({ tenant, goal }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.goals.show', { tenant, goal }));
	},

	GetGoalMomentum: async ({ tenant, goal }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.goals.momentum', { tenant, goal }));
	},

	UpdateGoal: async ({ tenant, goal }) => {
		// PATCH the goal to update sort_order (and other updatable fields)
		tenant = tenant || _tenant().slug;
		const id = goal.id;
		return await api().patch(
			getRoute('api.goals.update', { tenant, goal: id }),
			{ sort_order: goal.sort_order }
		);
	}
}

export const AchievementsRoutes = {

	GetAllAchievements: async (args) => {
		return await indexCallAdaptFormGame('achievements', args)
	}
}

export const VictoriesRoutes = {

	GetAllVictories: async (args) => {
		return await indexCallAdaptFormGame('victories', args)
	}
}

export const RewardsRoutes = {

	GetAllRewards: async (args) => {
		return await indexCallAdaptFormGame('rewards', args)
	},

	PingRewards: async () => {
		let tenant = _tenant().slug
		let sprint = _game()?.sprint ? _game().sprint.id : null;
		return await api().get(getRoute('api.rewards.ping', { tenant, sprint }));
	},

	GetReward: async ({ tenant, reward }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.rewards.show', { tenant, reward }));
	},

	CreateReward: async ({ tenant, reward }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.rewards.store', { tenant }), obj.objToFormData(reward));
	},

	UpdateReward: async ({ tenant, reward }) => {
		tenant = tenant || _tenant().slug
		reward._method = 'PATCH'
		return await api().post(getRoute('api.rewards.update', { tenant, reward }), obj.objToFormData(reward));
	},

	DeleteReward: async ({ tenant, reward }) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.rewards.destroy', { tenant, reward }));
	}
}

export const ClaimsRoutes = {

	GetAllClaims: async (args) => {
		args.tenant = args.tenant || _tenant().slug
		return await api().get(getRoute('api.claims.index', args));
	},

	CreateClaim: async ({ tenant, claim }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.claims.store', { tenant }), obj.objToFormData(claim));
	},

	SubtractCoins: async ({ tenant, coins, player_id }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.claims.subtract', { tenant }), obj.objToFormData({ coins, player_id }));
	},

	DeleteClaim: async ({ tenant, claim }) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.claims.destroy', { tenant, claim }));
	}
}

export const PostsRoutes = {

	GetAllPosts: async ({ tenant, page }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.posts.index', { tenant, page }));
	},

	GetPost: async ({ tenant, post }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.posts.show', { tenant, post }));
	},

	CreatePost: async ({ tenant, post }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.posts.store', { tenant }), obj.objToFormData(post));
	},

	DeletePost: async ({ tenant, post }) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.posts.destroy', { tenant, post }));
	},

	UpdatePost: async ({ tenant, post }) => {
		tenant = tenant || _tenant().slug
		post._method = 'PUT'
		return await api().post(getRoute('api.posts.update', { tenant, post }), obj.objToFormData(post));
	},

	LikeAPost: async ({ tenant, post }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.posts.storeLike', { tenant, post }));
	}
}

export const TipsRoutes = {

	GetAllTips: async (args = {}) => {
		args.tenant = args.tenant || _tenant().slug
		return await api().get(getRoute('api.tips.index', args));
	},

	GetTip: async ({ tenant, tip }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.tips.show', { tenant, tip }));
	},

	CreateTip: async ({ tenant, tip }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.tips.store', { tenant }), obj.objToFormData(tip));
	},

	ReplicateTip: async ({ tenant, tip }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.tips.replicate', { tenant, tip }), obj.objToFormData(tip));
	},

	UpdateTip: async ({ tenant, tip }) => {
		tenant = tenant || _tenant().slug
		tip._method = 'PATCH'
		return await api().post(getRoute('api.tips.update', { tenant, tip }), obj.objToFormData(tip));
	},

	DeleteTip: async ({ tenant, tip }) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.tips.destroy', { tenant, tip }));
	}

}

export const HubspotContactRoutes = {

	GetFields: async ({ tenant }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.hubspot.contacts.fields', { tenant }));
	},
	GetContact: async ({ tenant, contact }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.hubspot.contacts.show', { tenant, contact }));
	},
	CreateContact: async ({ tenant, contact }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.hubspot.contacts.store', { tenant }), obj.objToFormData(contact));
	},
	UpdateContact: async ({ tenant, contact }) => {
		tenant = tenant || _tenant().slug
		contact._method = 'PATCH'
		return await api().post(getRoute('api.hubspot.contacts.update', { tenant, contact }), obj.objToFormData(contact));
	},
	DeleteContact: async ({ tenant, contact }) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.hubspot.contacts.destroy', { tenant, contact }));
	},

}

export const HubspotCompanyRoutes = {

	GetFields: async ({ tenant }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.hubspot.companies.fields', { tenant }));
	},
	GetCompany: async ({ tenant, company }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.hubspot.companies.show', { tenant, company }));
	},
	CreateCompany: async ({ tenant, company }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.hubspot.companies.store', { tenant }), obj.objToFormData(company));
	},
	UpdateCompany: async ({ tenant, company }) => {
		tenant = tenant || _tenant().slug
		company._method = 'PATCH'
		return await api().post(getRoute('api.hubspot.companies.update', { tenant, company }), obj.objToFormData(company));
	},
	DeleteCompany: async ({ tenant, company }) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.hubspot.companies.destroy', { tenant, company }));
	},

}

export const HubspotDealRoutes = {

	GetFields: async ({ tenant }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.hubspot.deals.fields', { tenant }));
	},
	GetDeal: async ({ tenant, deal }) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.hubspot.deals.show', { tenant, deal }));
	},
	CreateDeal: async ({ tenant, deal }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.hubspot.deals.store', { tenant }), obj.objToFormData(deal));
	},
	UpdateDeal: async ({ tenant, deal }) => {
		tenant = tenant || _tenant().slug
		deal._method = 'PATCH'
		return await api().post(getRoute('api.hubspot.deals.update', { tenant, deal }), obj.objToFormData(deal));
	},
	DeleteDeal: async ({ tenant, deal }) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.hubspot.deals.destroy', { tenant, deal }));
	},

}
